import { useCallback, useState } from "react";

import { cn } from "@/lib/chillnn/cn";
import { useLockBodyScroll } from "@/lib/react-use/use-lock-body-scroll";

import { Button } from "@/components/ui/button/button";

type Props = {
	leftContent?: React.ReactElement;

	createNewItemList: { title: string; handleClick: () => void; canShow?: boolean }[];
};

export const ListTableHeader = ({ leftContent, createNewItemList }: Props) => {
	const [isShowNewItemList, setIsShowNewItemList] = useState(false);
	useLockBodyScroll(isShowNewItemList);

	const handleCreateNewItem = useCallback(() => {
		setIsShowNewItemList(!isShowNewItemList);
	}, [isShowNewItemList]);

	const handleClickCreateNewItem = useCallback(
		(handleClick: () => void) => () => {
			handleClick();
		},
		[],
	);

	const handleOutsideClick = useCallback(() => {
		setIsShowNewItemList(false);
	}, []);

	return (
		<div className="flex justify-between">
			<div>{leftContent}</div>

			<div className="relative">
				<Button onClick={handleCreateNewItem} variant={"default"} size={"lg"}>
					新規作成
				</Button>
				{isShowNewItemList && (
					<>
						<div
							className={cn(
								"fixed left-0 top-0 z-30 h-screen w-screen", //
								// "duration-200 animate-in fade-in-70",
							)}
							onClick={handleOutsideClick}
						/>
						<div className="absolute right-0 top-12 z-40">
							<ul
								className={cn(
									"flex w-52 flex-col gap-y-1 rounded border border-zinc-200 bg-white p-2 shadow",
									"animate-in fade-in-30 zoom-in-95 slide-in-from-top-1",
								)}
							>
								{createNewItemList.map((item, index) => {
									const canShow =
										item.canShow === undefined
											? true // 未定義の場合は表示
											: item.canShow;

									return (
										canShow && (
											<li
												key={`${item.title}-${index}`}
												className="cursor-pointer rounded p-2 hover:bg-zinc-100"
											>
												<a onClick={handleClickCreateNewItem(item.handleClick)}>{item.title}</a>
											</li>
										)
									);
								})}
							</ul>
						</div>
					</>
				)}
			</div>
		</div>
	);
};

ListTableHeader.displayName = "ListTableHeader";
